import { FunctionComponent } from 'react';
import {
  COUNTRIES,
  UserGroupInformationCard,
  UserGroupInformationCardTranslations,
  UserGroupInformationEditModal,
  UserGroupInformationEditModalTranslations,
} from '@cdaas/reusable-components-daas';
import { useTranslation } from 'react-i18next';
import { UserGroupRequest, UserGroupResponse } from '@cdaas/api-clients/dist/asset-admin-openapi';

interface BasicInformationProps {
  userGroup: UserGroupResponse;
  onEditButtonClick: () => void;
  onSaveButtonClick: (values: Pick<UserGroupRequest, 'name' | 'default_delivery_address'>) => Promise<boolean>;
  onCancelButtonClick: () => void;
  modalVisible: boolean;
}

export const BasicInformation: FunctionComponent<BasicInformationProps> = ({
  userGroup,
  onEditButtonClick,
  onSaveButtonClick,
  onCancelButtonClick,
  modalVisible,
}) => {
  const { t } = useTranslation('userGroups');
  const { t: tGlobal } = useTranslation('global');

  const userGroupInformationCardTranslations: UserGroupInformationCardTranslations = {
    title: t('basicInformation.title'),
    nameRowTitle: t('basicInformation.nameRowTitle'),
    deliveryAddressRowTitle: t('basicInformation.deliveryAddressRowTitle'),
    editButton: t('basicInformation.editButton'),
  };

  const userGroupInformationEditCardTranslations: UserGroupInformationEditModalTranslations = {
    editModeTitle: t('basicInformation.editModeTitle'),
    nameTitle: t('basicInformation.nameTitle'),
    nameInputLabel: t('basicInformation.nameInputLabel'),
    deliveryAddressTitle: t('basicInformation.deliveryAddressTitle'),
    deliveryAddressText: t('basicInformation.deliveryAddressText'),
    streetAddressInputLabel: t('basicInformation.streetAddressInputLabel'),
    address1InputLabel: t('basicInformation.address1InputLabel'),
    address2InputLabel: t('basicInformation.address2InputLabel'),
    postalCodeInputLabel: t('basicInformation.postalCodeInputLabel'),
    invalidPostalCode: t('basicInformation.invalidPostalCode'),
    cityInputLabel: t('basicInformation.cityInputLabel'),
    countryInputLabel: t('basicInformation.countryInputLabel'),
    fieldRequired: t('basicInformation.fieldRequired'),
    saveButton: t('basicInformation.saveButton'),
    closeButton: t('basicInformation.closeButton'),
    saveErrorTitle: t('basicInformation.saveErrorTitle'),
    saveErrorMessage: t('basicInformation.saveErrorMessage'),
    countries: {
      Finland: tGlobal('countries.Finland'),
      Sweden: tGlobal('countries.Sweden'),
      Norway: tGlobal('countries.Norway'),
      Denmark: tGlobal('countries.Denmark'),
      UnitedKingdom: tGlobal('countries.UnitedKingdom'),
    },
  };

  return (
    <>
      <UserGroupInformationCard
        translations={userGroupInformationCardTranslations}
        userGroup={userGroup}
        onEditButtonClick={onEditButtonClick}
        countries={COUNTRIES}
      />
      <UserGroupInformationEditModal
        translations={userGroupInformationEditCardTranslations}
        userGroup={userGroup}
        onUserGroupSave={onSaveButtonClick}
        onCloseModal={onCancelButtonClick}
        countries={COUNTRIES}
        hidden={!modalVisible}
      />
    </>
  );
};
